<div #top></div>
<router-outlet></router-outlet>
